import React from 'react';
import { Layout, Stat, Card } from '@components'
import { Account } from '@archetypes'
import styled from "styled-components"

const Sidebar = styled(
	({ className }) => {



		return (
			<div className={className}>
				<div className="title">Your Account</div>
				<Account.Balance />
			</div>
		)
	})`
		display: flex;
		flex-direction: column;
		width: 100%;
		
		.title {
			font-size: 32px;
			font-weight: 700; 
			line-height: 40px;
			margin-left: 10px;
			color: var(--color-white, white);
			margin-bottom: 10px;
		}
	`

export default ({ className }) => (
	<Layout>
		<Layout.Aside>
			<Sidebar />
		</Layout.Aside>
		<Layout.Main>
			<Layout.Section title='Your Positions'>
				<Account.CDPs />
			</Layout.Section>
			<Layout.Section title='Your Pools'>
				<Account.Pools />
			</Layout.Section>
		</Layout.Main>
	</Layout>
)